// Pure placeholder extraction / validation helpers for the Email Center composer.
// Mirrors the backend PlaceholderEngine's token grammar so highlighting never drifts.

const TOKEN_REGEX = /\{\{\s*([a-zA-Z0-9_.]+)\s*}}/g;

export function extractPlaceholders(text) {
    if (!text) return [];
    const found = new Set();
    let match;
    const regex = new RegExp(TOKEN_REGEX);
    while ((match = regex.exec(text)) !== null) {
        found.add(match[1]);
    }
    return Array.from(found);
}

/**
 * @param {string} text - subject + body content containing {{tokens}}
 * @param {string[]} knownTokens - canonical system placeholder tokens (from usePlaceholderCatalog)
 * @param {string[]} customTokens - per-campaign custom variable names the admin has already defined
 */
export function validatePlaceholders(text, knownTokens = [], customTokens = []) {
    const used = extractPlaceholders(text);
    const knownSet = new Set([...knownTokens, ...customTokens]);
    const unknown = used.filter((token) => !knownSet.has(token));
    const known = used.filter((token) => knownSet.has(token));
    return { used, known, unknown, hasUnknown: unknown.length > 0 };
}
